module.exports = __webpack_public_path__ + "img/es.b8c75e82.png";